import { Scope3Category } from '../../../services/common/scope3-category.interface';

export const scope3CategoriesCache = {
  list: [] as Scope3Category[],
  byId: new Map<number | string, Scope3Category>()
};

export function setScope3Categories(list: Scope3Category[]) {
  scope3CategoriesCache.list = list ?? [];
  scope3CategoriesCache.byId = new Map(
    (list ?? []).map(x => [x.id, x]) 
  );
}